import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, Input, Output } from "@angular/core";
import { MatSortModule, Sort } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { StationPerformance } from "../../models/station-performance.model";
import { PaginatorComponent, SortOrder, TableLoaderComponent } from "@merchant-webapp/components";
import { PageEvent } from "@angular/material/paginator";
import { TranslocoPipe } from "@jsverse/transloco";
import { DecimalPipe } from "@angular/common";
import { DashboardStore } from "../../services/dashboard.store";

@Component({
  selector: "er-location-performance-list",
  standalone: true,
  imports: [MatTableModule, MatSortModule, TableLoaderComponent, PaginatorComponent, TranslocoPipe, DecimalPipe],
  templateUrl: "./location-performance-list.component.html",
  styleUrls: ["./location-performance-list.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocationPerformanceListComponent {
  protected readonly dashboardStore = inject(DashboardStore);

  sortTable(sort: Sort) {
    this.dashboardStore.updateStationPerformanceSorting({
      sort_by: sort.active,
      // TODO: 
      sorting_direction: SortOrder[sort.direction as "asc" | "desc"],
    });
  }
}
